/**
 * This is a helper method that turn the colors dictionary into dropdown options
 * @param colors
 */
export const getAllColorsAsDropdownOptions = (colors: any) => {
    const options = [] as any;
    for (const key in colors) {
        for (const subkey in colors[key]) {
            if (subkey.toLowerCase().indexOf("contrast") === -1) {
                options.push({ displayName: `${key}.${subkey}`, value: `${key}.${subkey}` });
            }
        }
    }
    return options;
};
